/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const NoteIcon = /*#__PURE__*/ createSvgIcon(
  'NoteIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M7.75 15h4.494a.738.738 0 00.537-.214.714.714 0 00.219-.532.734.734 0 00-.215-.535.719.719 0 00-.534-.219H7.756a.738.738 0 00-.537.214.714.714 0 00-.219.532c0 .21.072.39.215.535A.719.719 0 007.75 15zm0-3h4.494a.738.738 0 00.537-.214.714.714 0 00.219-.532.734.734 0 00-.215-.535.719.719 0 00-.534-.219H7.756a.738.738 0 00-.537.214.714.714 0 00-.219.532c0 .21.072.39.215.535A.719.719 0 007.75 12zm-2.256 6c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 014 16.5v-13c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44h5.875a1.441 1.441 0 011.063.438l3.125 3.124A1.44 1.44 0 0116 6.625V16.5c0 .413-.147.766-.44 1.06-.295.293-.648.44-1.06.44H5.493zM11 6.25V3.5H5.5v13h9V7h-2.75a.726.726 0 01-.534-.216A.726.726 0 0111 6.25z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default NoteIcon;
